import Cookies from "../../components/Cookies";
import Header from "../../components/Sign/Header";
import { Signature } from "../../components/Signature/Signature";

const Settings = () => {
  return (
    <>
      <Header visible={false} currentStep={0} position="relative" />
      <Signature />
      <Cookies />
    </>
  );
};

export default Settings;
